// pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer'; // Renders the updated Footer component
import InstagramFeed from '../components/InstagramFeed';
import './NewHome.css';

function Home() {

  // Gallery items definition (doubled for CSS animation loop)
  const galleryItems = [
    { src: "/refounded-17.png", alt: "RefoundEd Social Media Logo" }, // Alt text improved
    { src: "/refounded-19.png", alt: "Social Media Event Announcement" }, // Alt text improved
    { src: "/refounded-06.png", alt: "Family learning together outdoors" }, // Alt text improved
    { src: "/refounded-07.png", alt: "Educator teaching young children" }, // Alt text improved
    { src: "/E11210AF-AEBA-4436-8C59-F7DDA052193C.jpeg", alt: "Children playing and learning outdoors" }, // Alt text improved
  ];
  const doubledGalleryItems = [...galleryItems, ...galleryItems];

  return (
    <div className="home-container">

      {/* Hero Section */}
      <section className="hero-section white-bg">
        <div className="hero-content-wrapper">
          <div className="hero-content">
            <div className="hero-text">
              <img src="/refounded-05.png" alt="RefoundEd Leaf Brain Logo" className="hero-brain-logo" />
              <h1>Expanding Minds.<br />Restoring Education.</h1>
              <p>
                At Refound Education, we're all about shaking up the traditional learning scene! We're on a mission to EXPAND EDUCATION through restorative processes and community-led initiatives, making learning more authentically inclusive, engaging, and fun for everyone.
              </p>
              <Link to="/listings" className="cta-button">
                EXPLORE OUR LISTINGS
              </Link>
            </div>
            <div className="hero-image-collage">
              {/* Alt text improved */}
              <img src="/refounded-03.png" alt="Collage showing diverse learning activities like nature exploration, art, and group projects" />
            </div>
          </div>
          <div className="hero-ribbon">
             <img src="/refounded-02.png" alt="Ribbon graphic stating Empowering educators and families" />
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="quote-section">
        <div className="quote-container">
          <p className="quote-text">
            "When we expand education through connection, we empower communities to rise, dream bigger, and lead the future with purpose. Together, we're not just changing education—we're transforming lives."
          </p>
          <p className="quote-author">-Jeannette Da Luz, Founder RefoundED</p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-item">
            {/* Alt text improved */}
            <img src="/refounded-10.png" alt="Statistic: 66% Increase in alternative education options since 2020" />
          </div>
          <div className="stat-separator"></div>
          <div className="stat-item">
            {/* Alt text improved */}
            <img src="/refounded-11.png" alt="Statistic: 300% Increase in homeschoolers seeking community support" />
          </div>
           <div className="stat-separator"></div>
          <div className="stat-item">
             {/* Alt text improved */}
            <img src="/refounded-12.png" alt="Statistic: 49+ Innovative edu-businesses launched through RefoundEd support" />
          </div>
           <div className="stat-separator"></div>
          <div className="stat-item">
            {/* Alt text improved */}
            <img src="/refounded-13.png" alt="Statistic: 15-25% Alternatively educated students scoring higher on standardized tests" />
          </div>
        </div>
      </section>

      {/* Image Grid Section */}
       <section className="image-grid-section">
         <div className="image-grid-container">
             {/* Alt text improved */}
             <div className="grid-image-item"><img src="/refounded-06.png" alt="Family learning together outdoors by a lake" /></div>
             <div className="grid-image-item"><img src="/6.png" alt="Child participating in an outdoor educational activity" /></div>
             <div className="grid-image-item"><img src="/refounded-07.png" alt="Educator reading a book to a group of children outdoors" /></div>
             <div className="grid-image-item"><img src="/819E8B4C-5927-4C54-84BA-39997CD2D644_1_105_c.jpeg" alt="Children gathered around a table for a community learning event" /></div>
             <div className="grid-image-item"><img src="/E11210AF-AEBA-4436-8C59-F7DDA052193C.jpeg" alt="Group of children playing tug-of-war outdoors" /></div>
             <div className="grid-image-item"><img src="/refounded-08.png" alt="Hands-on science experiment with colorful liquids" /></div>
             <div className="grid-image-item"><img src="/7.png" alt="Diverse group of children smiling during an activity" /></div>
             <div className="grid-image-item"><img src="/refounded-09.png" alt="Illustration of hands holding a plant, symbolizing growth and donation" /></div>
         </div>
       </section>

      {/* Meet the Founder Section */}
      <section className="founder-section">
        <div className="founder-container">
          <div className="founder-image">
            {/* Alt text improved */}
            <img src="/refounded-16.png" alt="Portrait of Jeannette Da Luz, Founder of RefoundEd" />
          </div>
          <div className="founder-content">
            <h2>Meet the Founder</h2>
            <h3 className="founder-signature">Jeannette Da Luz</h3>
            <p>
              Jeannette Da Luz is the visionary behind Refound Education,
              a cutting-edge education management company that provides
              support for grassroots educational and recreational initiatives
              for children and youth. With over two decades of experience
              in social services and education, Jeannette is an innovative
              educator committed to revolutionizing the education
              landscape.
            </p>
            <p>
              She has combined her expertise in technology,
              innovation, business, leadership, social emotional learning,
              behaviour management, and social marketing to create a
              company that offers educational solutions to families,
              educators, and the community, empowering them to reach
              their full potential in a rapidly changing world.
            </p>
            <a
              href="https://hihello.me/p/35a05478-3e01-4158-9859-b6ce109f991b"
              target="_blank"
              rel="noreferrer"
              className="founder-link"
            >
              MORE ABOUT JEANNETTE
            </a>
          </div>
        </div>
      </section>

      {/* Awards Section */}
      <section className="awards-section">
        <div className="awards-container">
           <img
              src="/refounded-14.png"
              // Alt text improved
              alt="Banner: Education 2.0 Conference Outstanding Leadership Award presented to Jeannette Da Luz, Dubai 2023"
              className="award-background-image"
            />
           <div className="award-video-embed">
             <iframe
               className="youtube-iframe"
               src="https://www.youtube.com/embed/ukbE4tsa2Ek"
               title="YouTube video player - RefoundEd Founder Jeannette Da Luz receiving Education 2.0 Award" // Improved title
               frameBorder="0"
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
               allowFullScreen
             ></iframe>
           </div>
        </div>
      </section>

      {/* Instagram Feed Section – replaces static carousel */}
      <section className="social-gallery-section">
        <h2>Follow Us on Instagram</h2>
        <p className="social-handle">@refoundeducation</p>
        <InstagramFeed />
      </section>

      {/* Educational Resources Section */}
      <section className="resources-section">
         <div
           className="resource-background"
           style={{ backgroundImage: `url(/refounded-18.png)` }} // Descriptive alt is applied to the link/image below
         >
            <div className="resource-content-centered">
                 <Link to="/listings/nyyYti197HXEfyx2nTYQ" className="playbook-link">
                     {/* Alt text improved */}
                    <img src="/refounded-24.png" alt="Cover: How to Open an Education Based Business Playbook - Click to view details" className="playbook-image"/>
                 </Link>
            </div>
         </div>
      </section>

      {/* Newsletter Signup Section */}
      <section className="newsletter-section">
        <div className="newsletter-container">
          <div className="newsletter-form">
            <h2>SIGN UP FOR OUR NEWSLETTER</h2>
            <p>Be the first to know about our new educators, new listings, and upcoming events.</p>
            {/* Note: Form needs actual submission logic */}
            <form className="signup-form" onSubmit={(e) => e.preventDefault()}>
              <input type="text" placeholder="FIRST NAME" className="form-input" aria-label="First Name"/>
              <input type="email" placeholder="EMAIL" className="form-input" aria-label="Email"/>
              <button type="submit" className="form-button">SUBSCRIBE</button>
            </form>
          </div>
          <div className="newsletter-image-collage">
             {/* Alt text improved */}
            <img src="/refounded-15.png" alt="Collage: People participating in community and educational activities" />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;